import React from 'react';
import FloatingChatBubble from './FloatingChatBubble/FloatingChatBubble';
import * as Styled from './ChatItem.styled';
import ScoreKeyHit from '../../../atoms/ScoreKeyHit/ScoreKeyHit';
import { Icon } from '@virtidev/toolbox';
import { useTheme } from 'styled-components';

/**
 * @type {import('react').FC<{}>}
 */
const ChatItem = ({ chatLog, children }) => {
  const { color } = useTheme();
  return (
    <Styled.Item $chatType={chatLog?.chatType}>
      <Styled.ChatBubbleWrapper>
        {chatLog?.isAIFallback && (
          <Styled.IsAIIconWrapper title="This was response generated by OpenAI">
            <Icon icon="brain" color={color.secondary} size="1.5rem" />
          </Styled.IsAIIconWrapper>
        )}
        <FloatingChatBubble>
          {chatLog?.text}
          {children}
        </FloatingChatBubble>
        {chatLog?.scoreMetadataWithCalculated && (
          <ScoreKeyHit
            scoreMetadataWithCalculated={chatLog.scoreMetadataWithCalculated}
            top="-15px"
          />
        )}
      </Styled.ChatBubbleWrapper>
    </Styled.Item>
  );
};

export default ChatItem;
